import { useQuery, useQueryClient } from 'react-query';

import type { GetApiOptions } from '../../types/api';

export function useGetApi<TData, TError = unknown>({
  queryKey,
  request,
  ...options
}: GetApiOptions<TData, TError>) {
  const queryClient = useQueryClient();
  const result = useQuery<TData, TError>(queryKey, request, options);

  return {
    ...result,
    invalidate: () => queryClient.invalidateQueries(queryKey),
  };
}
